// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { Filters_ItemLocationFragmentDoc } from '../../libraries/plan-package/takeoffs/PlanPackageTakeoffSideBar.generated';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductOfferingScopePageSideBarQueryVariables = Types.Exact<{
  productOfferingId: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type ProductOfferingScopePageSideBarQuery = { __typename?: 'Query', productOffering: { __typename?: 'ProductOffering', id: string, itemLocations: Array<{ __typename?: 'Location', id: string, name: string, parents: Array<{ __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', name: string, code: Types.LocationType } }>, type: { __typename?: 'LocationTypeDetail', name: string, code: Types.LocationType } }>, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, order: number, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isProductOptionV2: boolean, isPackageOptionV2: boolean }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string } }>, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }> } };

export type ProductOfferingScopePageSideBar_FiltersFragment = { __typename?: 'ProductOffering', id: string, itemLocations: Array<{ __typename?: 'Location', id: string, name: string, parents: Array<{ __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', name: string, code: Types.LocationType } }>, type: { __typename?: 'LocationTypeDetail', name: string, code: Types.LocationType } }>, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, order: number, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isProductOptionV2: boolean, isPackageOptionV2: boolean }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string } }>, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }> };

export const ProductOfferingScopePageSideBar_FiltersFragmentDoc = gql`
    fragment ProductOfferingScopePageSideBar_Filters on ProductOffering {
  id
  itemLocations {
    ...Filters_ItemLocation
  }
  options {
    id
    displayName
    order
    type {
      id
      isElevation
      isProductOptionV2
      isPackageOptionV2
    }
    optionGroup {
      id
      name
    }
  }
  costCodes {
    ...Named
  }
}
    ${Filters_ItemLocationFragmentDoc}
${NamedFragmentDoc}`;
export const ProductOfferingScopePageSideBarDocument = gql`
    query ProductOfferingScopePageSideBar($productOfferingId: ID!, $versionId: ID!) {
  productOffering(id: $productOfferingId, versionId: $versionId) {
    ...ProductOfferingScopePageSideBar_Filters
  }
}
    ${ProductOfferingScopePageSideBar_FiltersFragmentDoc}`;

/**
 * __useProductOfferingScopePageSideBarQuery__
 *
 * To run a query within a React component, call `useProductOfferingScopePageSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingScopePageSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingScopePageSideBarQuery({
 *   variables: {
 *      productOfferingId: // value for 'productOfferingId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useProductOfferingScopePageSideBarQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingScopePageSideBarQuery, ProductOfferingScopePageSideBarQueryVariables> & ({ variables: ProductOfferingScopePageSideBarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingScopePageSideBarQuery, ProductOfferingScopePageSideBarQueryVariables>(ProductOfferingScopePageSideBarDocument, options);
      }
export function useProductOfferingScopePageSideBarLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingScopePageSideBarQuery, ProductOfferingScopePageSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingScopePageSideBarQuery, ProductOfferingScopePageSideBarQueryVariables>(ProductOfferingScopePageSideBarDocument, options);
        }
// @ts-ignore
export function useProductOfferingScopePageSideBarSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingScopePageSideBarQuery, ProductOfferingScopePageSideBarQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingScopePageSideBarQuery, ProductOfferingScopePageSideBarQueryVariables>;
export function useProductOfferingScopePageSideBarSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingScopePageSideBarQuery, ProductOfferingScopePageSideBarQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingScopePageSideBarQuery | undefined, ProductOfferingScopePageSideBarQueryVariables>;
export function useProductOfferingScopePageSideBarSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingScopePageSideBarQuery, ProductOfferingScopePageSideBarQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingScopePageSideBarQuery, ProductOfferingScopePageSideBarQueryVariables>(ProductOfferingScopePageSideBarDocument, options);
        }
export type ProductOfferingScopePageSideBarQueryHookResult = ReturnType<typeof useProductOfferingScopePageSideBarQuery>;
export type ProductOfferingScopePageSideBarLazyQueryHookResult = ReturnType<typeof useProductOfferingScopePageSideBarLazyQuery>;
export type ProductOfferingScopePageSideBarSuspenseQueryHookResult = ReturnType<typeof useProductOfferingScopePageSideBarSuspenseQuery>;
export type ProductOfferingScopePageSideBarQueryResult = Apollo.QueryResult<ProductOfferingScopePageSideBarQuery, ProductOfferingScopePageSideBarQueryVariables>;